import { SvgIcon } from "@material-ui/core";
import React from "react";

import { StatusBadgeProps } from "./statusBadgeProps";

export const JobPriorityBBadge = (props: StatusBadgeProps) => {
    const {
        width = "24",
        height = "24",
        viewBox = "0 0 20 20",
        ...rest
    } = props;

    return (
        <svg
            width={width}
            height={height}
            viewBox={viewBox}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                width="20"
                height="20"
                rx="3"
                fill="#A6D3F4"
                fillOpacity="0.8"
            />
            <path
                d="M7.48244 14H10.4839C12.1169 14 13.0714 13.149 13.0714 11.6885C13.0714 10.665 12.5999 9.9865 11.7144 9.699C12.3124 9.3885 12.6574 8.779 12.6574 7.997C12.6574 6.732 11.7259 5.9845 10.1619 5.9845H7.48244V14ZM8.71294 9.2735V7.123H10.1619C10.9669 7.123 11.4269 7.514 11.4269 8.2155C11.4269 8.894 10.9899 9.2735 10.2194 9.2735H8.71294ZM8.71294 12.8615V10.389H10.4609C11.3464 10.389 11.8409 10.826 11.8409 11.585C11.8409 12.39 11.3004 12.8615 10.3804 12.8615H8.71294Z"
                fill="#21006E"
            />
        </svg>
    );
};
